import { render, staticRenderFns } from "./DubunSvg.vue?vue&type=template&id=8e469e6c&scoped=true&"
import script from "./DubunSvg.vue?vue&type=script&lang=js&"
export * from "./DubunSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e469e6c",
  null
  
)

export default component.exports